module.exports = __webpack_public_path__ + "img/5.7c37a21a.png";